import { Button } from '@components/_ui/Button'
import { useFetch } from '@hooks/useFetch'
import { useEffect } from 'react'

import s from './ErrorBoundaryFallbackComponent.module.scss'
import type { ErrorBoundaryFallbackComponentProps } from './ErrorBoundaryFallbackComponent.props'

export function ErrorBoundaryFallbackComponent({ error, resetErrorBoundary }: ErrorBoundaryFallbackComponentProps) {
  const { trigger: sendError } = useFetch('quiz_error')

  useEffect(() => {
    console.error('error', error)
    sendError({ data: error?.toString() })
  }, [error])

  return (
    <div className={s.wrapper}>
      <h1 className={s.title}>Something went wrong</h1>
      <Button onClick={resetErrorBoundary}>Try again</Button>
    </div>
  )
}
